import { useState } from 'react';
import { Check, ChevronsUpDown, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../ui/command';
import { cn } from '../../lib/utils';

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);

/** Searchable, grouped dropdown used for every cinematography / catalog choice. */
export function CineCombo({ label, value, options, groups, onChange, placeholder = 'Auto (AI decides)', testId, className }) {
  const [open, setOpen] = useState(false);
  const sets = groups || [{ heading: '', items: options || [] }];
  const pick = (v) => { onChange(v); setOpen(false); };
  return (
    <div className={cn('min-w-0 space-y-1', className)}>
      {label && <div className="text-[10px] font-semibold uppercase tracking-[0.16em] text-neutral-500">{label}</div>}
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            className={cn(
              'flex w-full items-center justify-between gap-2 rounded-md border bg-neutral-950 px-2.5 py-2 text-left text-xs transition-colors',
              value ? 'border-amber-400/40 text-amber-100' : 'border-neutral-800 text-neutral-500 hover:border-neutral-600',
            )}
          >
            <span className="truncate">{value || placeholder}</span>
            <ChevronsUpDown size={12} className="shrink-0 opacity-60" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-[300px] border-neutral-800 bg-neutral-950 p-0 text-neutral-200">
          <Command className="bg-neutral-950">
            <CommandInput placeholder={`Search ${(label || 'options').toLowerCase()}…`} data-testid={testId ? `${testId}-search` : undefined} />
            <CommandList className="max-h-72">
              <CommandEmpty>No match.</CommandEmpty>
              {value && (
                <CommandItem value="__clear__" onSelect={() => pick('')} className="text-neutral-400">
                  <X size={12} className="mr-2" /> Clear — let the AI decide
                </CommandItem>
              )}
              {sets.map((g) => (
                <CommandGroup key={g.heading || 'all'} heading={g.heading || undefined}>
                  {g.items.map((o) => (
                    <CommandItem
                      key={`${g.heading}-${o}`}
                      value={`${g.heading} ${o}`}
                      onSelect={() => pick(o)}
                      data-testid={testId ? `${testId}-opt-${slug(o)}` : undefined}
                    >
                      <Check size={12} className={cn('mr-2 text-amber-300', value === o ? 'opacity-100' : 'opacity-0')} />
                      {o}
                    </CommandItem>
                  ))}
                </CommandGroup>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
